// extracted by mini-css-extract-plugin
export default {"badgeContainer":"NotificationBadge_badgeContainer__Pk370","badge":"NotificationBadge_badge__A3K5k"};